export default {
  BASE_URL: 'https://dotconnect.dotandkey.com/api/v2',
  CREAD: 'CREAD',
  TOKEN: 'TOKEN',
};